import { Component, Input } from '@angular/core';
import { CpdEntry } from '../../../model/CpdEntry';
import { AnswerType } from '../../../../dynamic/model/AnswerType';
@Component({
    selector: 'app-cpd-entry-answers',
    templateUrl: './cpdEntryAnswers.component.html',
    standalone: false
})
export class CpdEntryAnswersComponent {

  @Input() cpdEntry: CpdEntry;
  AnswerType = AnswerType;

}
